var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPublication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#445BC7",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 11.3333H11.9999C11.8231 11.3333 11.6535 11.4035 11.5285 11.5285C11.4035 11.6535 11.3333 11.8231 11.3333 11.9999V23.9999C11.3333 24.1767 11.4035 24.3463 11.5285 24.4713C11.6535 24.5963 11.8231 24.6666 11.9999 24.6666H23.9999C24.1767 24.6666 24.3463 24.5963 24.4713 24.4713C24.5963 24.3463 24.6666 24.1767 24.6666 23.9999V11.9999C24.6666 11.8231 24.5963 11.6535 24.4713 11.5285C24.3463 11.4035 24.1767 11.3333 23.9999 11.3333ZM15.3333 23.3333H12.6666V12.6666H15.3333V23.3333ZM23.3333 23.3333H16.6666V18.6666H23.3333V23.3333ZM23.3333 17.3333H16.6666V12.6666H23.3333V17.3333Z",
    fill: "#445BC7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublication);
export default __webpack_public_path__ + "static/media/publication.0e944bc2622d2492ab48292575cda295.svg";
export { ForwardRef as ReactComponent };